import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default function Ai_department() {
    return (
        <>
            <Header />
            <main>
                <section class="pad breadcrumbs top-cover">
                    <div id="breadcrumb" class="content">
                        <a href="Home">Home</a><i></i>
                        <span>Artificial Innovation Department</span>
                    </div>
                </section>


                <section class="pad bank-benefits default margin-top-content">

                    <div class="content normal">
                        <div data-lavalamp=""></div>

                        <div class="img-frame">
                            <img src="images/nugenesisou/pr-illustration-20.png" alt="" />
                        </div>

                        <div class="data">
                            <div class="text">
                                <h3 class="title">AI Digital Art Generator</h3>

                                <p class="subtitle">
                                    AI Photo Generator developed and designed by Nugenesis AI Department, real to life photo illustrations
                                </p>

                            </div>
                            <div class="btns">
                                <a href="document/Al-Abdallah.pdf" target="_blank" data-patt="track-btn" class="">Download</a>
                            </div>
                            <br></br>
                            <div class="text">
                                <h3 class="title">Resurrection Protocol</h3>

                                <p class="subtitle">
                                    A ressurection protocol unique to the Nugenesis Network utalises AI to learn traits
                                    and how individuals have lived through biographies, and collected data to create a
                                    Meta version
                                </p>

                            </div>
                            <div class="btns">
                                <a href="document/AI-Resurrections-Protocol.zip" target="_blank" data-patt="track-btn" class="">Download</a>
                            </div>
                        </div>


                    </div>

                </section>




                <section class="pad bank-benefits white ">
                    <div class="content normal">
                        <div data-lavalamp=""></div>

                        <div class="data text-width-half">
                            <div class="text">
                                <h3 class="title">Nugenesis Blockchain White Paper</h3>
                                
                                <div class="margin-top-content5">
                                    <h4 class="title small-title ">Part A- White Paper</h4>

                                    <p class="subtitle">
                                        Introduction and Summary of the White Paper
                                    </p>
                                    <div class="btns">
                                        <a href="document/PART-A-INTRO-AND-SUMMARY-WHITE-PAPER.docx" target="_blank" data-patt="track-btn" class="">Download</a>

                                    </div>
                                </div>

                                <div class="margin-top-content5">
                                    <h4 class="title small-title ">Part B- White Paper</h4>

                                    <p class="subtitle">
                                        Technology Paper of the White Paper
                                    </p>

                                    <div class="btns">
                                        <a href="document/PART-A-INTRO-AND-SUMMARY-WHITE-PAPER.docx" target="_blank" data-patt="track-btn" class="">Download</a>

                                    </div>

                                </div>

                                <div class="margin-top-content5">
                                    <h4 class="title small-title ">Part C- White Paper</h4>

                                    <p class="subtitle">
                                    Solving For Mass Adoption
                                    </p>

                                    <div class="btns">
                                        <a href="document/PART-C-TECH-PAPER.docx" target="_blank" data-patt="track-btn" class="">Download</a>

                                    </div>

                                </div>


                            </div>
                        </div>

                        <div class="data">
                            <div class="text">

                            <div class="margin-top-content-7">
                                    <h4 class="title small-title ">Part D- White Paper</h4>

                                    <p class="subtitle">
                                            The Legal Issues
                                    </p>
                                    <div class="btns">
                                        <a href="document/part-D-legal-issues.docx" target="_blank" data-patt="track-btn" class="">Download</a>

                                    </div>
                                </div>

                                <div class="margin-top-content5">
                                    <h4 class="title small-title ">Part E- White Paper</h4>

                                    <p class="subtitle">
                                            Disclosures and Risks
                                    </p>

                                    <div class="btns">
                                        <a href="document/Part-E-RISKS-Whitepaper.docx " target="_blank" data-patt="track-btn" class="">Download</a>

                                    </div>

                                </div>

                                
                               
                            </div>
                        </div>

                    </div>

                </section>

            </main>
            <Footer />
        </>
    )
}